<section class="inbox__container">
  <div class="inbox__description">
    <p>{{ config.description }}</p>
  </div>

  <div class="inbox__header" data-test-id="InboxHeader">
    @if (config.isSelectable) {
      <div class="inbox__select">
        <icon
          [name]="
            areAllRowsSelected()
              ? 'checkbox_active'
              : selectedMessages.length > 0
                ? 'checkbox_all'
                : 'checkbox'
          "
          [config]="{
            size: 'medium',
            set: 'system',
            type: 'pointer',
            fill: selectedMessages.length > 0 ? 'primary' : 'text--1',
          }"
        >
        </icon>
      </div>
    }

    @if (selectedMessages.length !== 0) {
      <div class="inbox__selection" data-test-id="InboxSelection">
        <div
          class="inbox__selection__action"
          (click)="selectionActionClicked.emit(selectedMessages)"
          data-test-id="InboxSelectionAction"
        >
          <icon
            [name]="datagridConfig.selectionAction.icon"
            [config]="{
              size: 'medium',
              set: 'system',
              type: 'link',
              format: 'svg',
            }"
          >
          </icon>
          <p class="inbox__selection__action__label">
            {{ datagridConfig.selectionAction.label }}
          </p>
        </div>
        <status
          [config]="{
            label: selectedMessages.length + ' Rows Selected',
          }"
          status="success"
          data-test-id="InboxStatus"
        >
        </status>
      </div>
    }
  </div>

  <div class="inbox__body" data-test-id="InboxBody">
    @if (messages) {
      @if (messages.length > 0) {
        @for (message of messages; track message; let i = $index) {
          <section>
            <div
              class="inbox__message"
              [attr.data-test-id]="'InboxMessage_' + i"
            >
              @if (datagridConfig.isSelectable) {
                <div
                  class="inbox__select"
                  [attr.data-test-id]="'InboxMessageSelector_' + i"
                >
                  <icon
                    [name]="
                      isMessageSelected(message)
                        ? 'checkbox_active'
                        : 'checkbox'
                    "
                    [config]="{
                      type: 'pointer',
                      fill: isMessageSelected(message) ? 'primary' : 'text--1',
                    }"
                    (click)="toggleMessage(message)"
                  >
                  </icon>
                </div>
              }
              <div
                class="u-maxX"
                [ngClass]="{
                  inbox__message__selectable: datagridConfig.isSelectable,
                }"
                (click)="messageClicked.emit(message)"
              >
                <div class="u-flex u-justifyBetween u-fillRemaining">
                  <p
                    [ngClass]="{
                      't-bold': message.is_read === false,
                    }"
                    [attr.data-test-id]="'InboxMessageText_' + i"
                  >
                    {{ message.name }}
                  </p>
                  <p>{{ formattedDate(message) }}</p>
                </div>
                <div class="u-flex u-justifyBetween">
                  <p [attr.data-test-id]="'InboxMessageCategory' + i">
                    {{ message.category }}
                  </p>
                  @if (message.has_attachment) {
                    <icon
                      name="attachment"
                      [config]="{
                        size: 'medium',
                        set: 'system',
                        format: 'svg',
                      }"
                    >
                    </icon>
                  }
                </div>
                <p>{{ message.subject }}</p>
                <p class="inbox--ellipsis">{{ message.preview }}</p>
                <p>{{ message.case_number }}</p>
              </div>
            </div>
          </section>
        }
      } @else {
        @if (!config?.hideNoMessageBox) {
          <p data-test-id="InboxBodyNoData">You have no messages.</p>
        }
      }
    }
  </div>
</section>
